<template>
    <p class="font10 textcenter" style="color: #666">
        Alle genoemde prijzen zijn per persoon op basis van een 2-persoonshut.
        De prijzen kunnen wijzigen en zijn onder voorbehoud van beschikbaarheid.
        De aangeboden cruises zijn standaard op basis van volpension tenzij
        anders aangegeven, daarnaast zijn belastingen en havengelden altijd
        inbegrepen in de getoonde prijs. Tenzij anders aangegeven, zijn de
        prijzen standaard exclusief vlucht(en), transfer(s) en fooien. Alle
        vluchten zijn op basis van handbagage, ruimbagage is optioneel bij te
        boeken.<br />
        <a class="font10" href="https://www.cruisereizen.nl/privacy">
            De Privacy Policy van CruiseReizen B.V. is van toepassing
        </a>
    </p>
</template>

<script>
export default {
    name: 'prijzenDisclaimer',
}
</script>

<style scoped>
p > a {
    font-weight: normal;
}
</style>
